import { NgModule } from '@angular/core';
import { MaskDirective } from './mask/mask';
import { MaskCurrencyDirective } from './mask-currency/mask-currency';
@NgModule({
	declarations: [MaskDirective,
    MaskCurrencyDirective],
	imports: [],
	exports: [MaskDirective,
    MaskCurrencyDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/directives/directives.module.ts